class ApiService {

  constructor($http, LoaderService) {
    var self = this;
    self.http = $http;
    self.host = "";
    self.LoaderService = LoaderService;
  }

  get(endpoint) {
    var self = this;
    return self.http.get(self.host + endpoint)
        .then( (data) => {
          return data;
        } );
  }

  post(endpoint, data) {
    var self = this;
    var url = self.host + endpoint;
    return self.http.post(url, data);
  }

  put(endpoint, data) {
    var self = this;
    var url = self.host + endpoint;
    return self.http.put(url, data);
  }

  _delete(endpoint) {
    var self = this;
    var url = self.host + endpoint;
    return self.http.delete(url);
  }

  patch(endpoint, data) {
    var self = this;
    var url = self.host + endpoint;
    return self.http.patch(url, data);
  }

}
ApiService.$inject = ['$http', 'LoaderService'];
export default ApiService;
